var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXamarin2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.82 107.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo-2",
    className: "cls-1",
    d: "m34.86,0c-3.33.05-6.4,1.83-8.1,4.7L1.21,49.2c-1.62,2.92-1.62,6.47,0,9.4l25.55,44.5c1.7,2.87,4.77,4.65,8.1,4.7h51.09c3.33-.05,6.4-1.83,8.1-4.7l25.55-44.5c1.62-2.92,1.62-6.47,0-9.4L94.06,4.7c-1.7-2.87-4.76-4.65-8.09-4.7h-51.1Zm.46,26.03c.07,0,.14,0,.21,0h8.81c.4.01.76.23.96.57l14.96,26.72c.08.13.12.28.14.43.02-.15.07-.3.14-.43l14.92-26.72c.21-.35.59-.57,1-.57h8.81c.66.06,1.15.65,1.09,1.31-.01.13-.04.25-.1.37l-14.6,26.18,14.6,26.14c.28.6.03,1.32-.58,1.61-.13.06-.28.1-.42.11h-8.81c-.42,0-.8-.24-1-.61l-14.92-26.71c-.08-.13-.13-.28-.15-.43-.02.15-.07.3-.14.43l-14.95,26.72c-.19.36-.56.59-.96.61h-8.81c-.67-.05-1.16-.63-1.11-1.3.01-.15.05-.29.11-.42l14.6-26.14-14.6-26.18c-.29-.6-.03-1.32.57-1.61.07-.03.14-.06.22-.08h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXamarin2);
export default __webpack_public_path__ + "static/media/xamarin2.ee42e72fccd25f227ccea0bb59bcd572.svg";
export { ForwardRef as ReactComponent };